import script from "./RelatoriosView.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatoriosView.vue?vue&type=script&setup=true&lang=js"

import "./RelatoriosView.vue?vue&type=style&index=0&id=4e6feb8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6feb8e"]])

export default __exports__